module.exports = __webpack_public_path__ + "images/archiverFolder.png";


//////////////////
// WEBPACK FOOTER
// ./data/demoContent/Views/images/archiverFolder.png
// module id = 613
// module chunks = 0